import React, { useState } from 'react';
import ModelViewer from './components/ModelViewer/ModelViewer';

function App() {

  //IMPORTANTE: DEJAR EN FALSE CUANDO SE VAYA A DESPLEGAR
  const MODO_TESTING = false;

  //DATOS DE CADA MODELO
  const datosLab = {
    id: 'lab',
    modelPath: "/assets/modelos3d/labcastrena.splat",
    initialCamera: [4.54, 2, -1.17],
    initialLookAt: [0, 0, 0],
    rotation: [0, 0, 0],
    maps: [
      {
        name: "General",
        image: "/assets/images/mapa-lab.png?v=2",
        points: [
          { label: "Localizacion 1", top: 66, left: 15, camPosition: [4.54, 2, -1.17] },
          { label: "Localizacion 2", top: 53, left: 65, camPosition: [-3, 2, 0] }
        ],
        navigation: [
          {
            position: [2.0, 0, -0.5],
            rotationY: -Math.PI / 2,
            visibleFrom: "Localizacion 1",
            targetLabel: "Localizacion 2",
            label: "Ir a Localizacion 2",
            
          },
          {
            position: [-1.0, 0, 0],
            rotationY: Math.PI / 2,
            visibleFrom: "Localizacion 2",
            targetLabel: "Localizacion 1",
            label: "Ir a Localizacion 1",
          }
        ],
        annotations: [
          { 
            title: "Fermentador", 
            content: (
              <>
                <p>Esto es una anotacion.</p>

                <img 
                  src="/assets/images/annotations/fermentador.png" 
                  alt="fermentador" 
                  style={{ width: '100%', borderRadius: '8px', marginTop: '10px', marginBottom: '10px' }} 
                />

                <p style={{ fontSize: '0.9em', color: '#ccc' }}>
                  <i>Fig 1. Fermentador.</i>
                </p>
              </>
            ),
            position: [-3.5, 2.0, -2.5], 
            maxDistance: 5,
            maxXDistance: 2,
            maxYDistance: 3,
            maxZDistance: 5,
          }
        ]
      }
    ]
  };

  const datosGaitero = {
    id: 'gaitero',
    modelPath: "/assets/modelos3d/gaiteromuseo_hq.splat",
    initialCamera: [-0.33, -0.26, -1.09],
    initialLookAt: [3.33, 4.26, 5.0],
    rotation: [Math.PI / 2, 0, 0],
    maps: [
      {
        name: "Museo",
        image: "/assets/images/mapa-museogaitero.png",
        points: [
          { label: "Planta 1", top: 37, left: 24, camPosition: [-0.33, -0.26, -1.09] },
          { label: "Planta 2", top: 37, left: 75, camPosition: [-0.45, 3.99, 1.10] },
          { label: "Expositores", top: 62, left: 58, camPosition: [-5.41, 4.17, 4.93] }
        ],
        navigation: [
          {
            position: [-0.33, -1.3, 0.69], 
            rotationY: 0,
            visibleFrom: "Planta 1",
            targetLabel: "Planta 2",
            label: "Subir escaleras",
            path: [
              [-0.33, 0, 2.0],
              [0.5, 2, 6.9],
              [-0.8, 2, 6.9],
              [-1.3, 3.9, 2.8],
            ]
          },
          {
            position: [-1.2, 2.8, 2.8], 
            rotationY: 0,
            visibleFrom: "Planta 2",
            targetLabel: "Planta 1",
            label: "Bajar escaleras",
            path: [
              [-1.3, 3.9, 2.8],
              [-0.8, 2, 6.9],
              [0.5, 2, 6.9],
              [-0.33, 0, 2.0],
            ]
          },
          {
            position: [-2.13, 2.8, 2.8], 
            rotationY: Math.PI * 1.75,
            visibleFrom: "Planta 2",
            targetLabel: "Expositores",
            label: "Ver expositores",
            path: [
              [-1.8, 3.9, 2.8],
              [-4.3, 3.99, 4],

            ]
          },
          {
            position: [-4.41, 2.8, 3.73], 
            rotationY: Math.PI / 1.5,
            visibleFrom: "Expositores",
            targetLabel: "Planta 2",
            label: "Volver",
            path: [
              [-4.3, 3.99, 4],
              [-1.8, 3.9, 2.8],
            ]
          }
        ],
        annotations: [
          { 
            title: "Anotacion 2",
            content: (
              <>
                <p>Esto es un texto y abajo hay una imagen.</p>
                <img 
                  src="/assets/images/annotations/cartel-gaitero.png" 
                  alt="Detalle" 
                  style={{ width: '100%', borderRadius: '8px', marginTop: '10px', marginBottom: '10px' }} 
                />

                <p style={{ fontSize: '0.9em', color: '#ccc' }}>
                  <i>Fig 1. Objeto.</i>
                </p>
                
                <p>Lista de <b style={{ color: '#61dafb' }}>objetos</b>:</p>
                <ul style={{ paddingLeft: '20px', marginTop: '5px' }}>
                  <li>Objeto I</li>
                  <li>Objeto II</li>
                </ul>
              </>
            ),
            position: [-10.33, 5.00, -6.09],
            maxDistance: 13,
            maxYDistance: 5,
            maxXDistance: 15,
            maxZDistance: 8,
          },
          { 
            title: "Anotacion 1",
            content: (
              <>
                <p>
                  Lorem ipsum dolor sit amet, consectetur adipiscing elit. Etiam nisl enim, laoreet vitae convallis placerat, finibus non ante. 
                  Nullam posuere sodales volutpat. Suspendisse mattis ante condimentum ipsum viverra, et efficitur neque sollicitudin. 
                  Phasellus suscipit est a tortor placerat tincidunt. Integer sed nunc non quam imperdiet hendrerit. 
                  Fusce sollicitudin justo augue, eu sollicitudin dolor luctus vel. Phasellus mauris mi, consectetur vitae erat sit amet, 
                  maximus viverra augue. Aliquam augue ipsum, eleifend a turpis in, sagittis sollicitudin tortor. Donec lacinia ligula at 
                  bibendum ornare. Proin facilisis quam velit, venenatis aliquam nisl blandit accumsan. Nullam id augue sapien. 
                  Vivamus efficitur felis ut nulla vulputate ultrices. Integer egestas lectus eu ultricies tincidunt.
                </p>
              </>
            ),
            position: [-1.45, -0.15, -1.10],
            maxDistance: 5,
            maxXDistance: 10,
            maxYDistance: 3
          }
        ]
      }
    ]
  };

  const datosCoche = {
    id: 'coche',
    modelPath: "/assets/modelos3d/coche_mq.splat",
    collisionPath: "/assets/modelos3d/coche_colision.obj",
    orbitMode: true,
    initialCamera: [3, 2, 4],
    initialLookAt: [0, 0, 0],
    rotation: [0, 0, 0],
    position: [0, 0, 0],
    collisionRotation: [-Math.PI / 2, 0, 28 * (Math.PI / 180)],
    collisionPosition: [-2.55, 1.6, -3.9],
    maps: []
  };

  const datosBombeo = {
    id: 'bombeo',
    modelPaths: {
      alta: "/assets/modelos3d/bombeo_hq.splat",
      media: "/assets/modelos3d/bombeo_mq.splat",
      baja: "/assets/modelos3d/bombeo_lq.splat"
    },
    initialCamera: [1, 0, -1],
    initialLookAt: [0, 0, 0],
    rotation: [Math.PI / 2, 0, 0],
    position: [0, 0, 0],
    maps: [
      {
        name: "General",
        image: "/assets/images/mapa-bombeo.png",
        points: [
          { label: "Localizacion 1", top: 26, left: 57, camPosition: [1, 0, -1] },
          { label: "Localizacion 2", top: 54, left: 48, camPosition: [-1, 0, 2] },
          { label: "Localizacion 3", top: 52, left: 28, camPosition: [-4, 0, 1.5] },
          { label: "Localizacion 4", top: 88, left: 52, camPosition: [1, -0.4, 5] },
        ],
        navigation: [
          { //L1a4
            position: [2, -1.3, -1.5], 
            rotationY: 90 * (Math.PI / 180),
            visibleFrom: "Localizacion 1",
            targetLabel: "Localizacion 4",
            label: "Ir a Localizacion 4",
            path: [
              [3.6, 0, -1],
              [4, -0.2, 3],
            ]
          },
          {
            position: [2, -1.8, 4.5], 
            rotationY: 120 * (Math.PI / 180),
            visibleFrom: "Localizacion 4",
            targetLabel: "Localizacion 1",
            label: "Ir a Localizacion 1",
            path: [
              [4, -0.2, 3],
              [3.6, 0, -1],
            ]
          },
          { //L1a2
            position: [1, -1.3, 0], 
            rotationY: 0 * (Math.PI / 180),
            visibleFrom: "Localizacion 1",
            targetLabel: "Localizacion 2",
            label: "Ir a Localizacion 2",
            path: [
              [1, 0, 1],
            ]
          },
          {
            position: [-0.6, -1.3, 1.6], 
            rotationY: 120 * (Math.PI / 180),
            visibleFrom: "Localizacion 2",
            targetLabel: "Localizacion 1",
            label: "Ir a Localizacion 1",
            path: [
              [1, 0, 1],
            ]
          },
          { //L1a3
            position: [-0.5, -1.3, -1.5], 
            rotationY: -90 * (Math.PI / 180),
            visibleFrom: "Localizacion 1",
            targetLabel: "Localizacion 3",
            label: "Ir a Localizacion 3",
            path: [
              [-4, 0, -1],
            ]
          },
          {
            position: [-4, -1.3, 0.5], 
            rotationY: 180 * (Math.PI / 180),
            visibleFrom: "Localizacion 3",
            targetLabel: "Localizacion 1",
            label: "Ir a Localizacion 1",
            path: [
              [-4, 0, -1],
            ]
          },
        ]
      }
    ]
  };

  //====================

  const [activeData, setActiveData] = useState(null);
  const [selectedPath, setSelectedPath] = useState(null);
  const [isHelpOpen, setIsHelpOpen] = useState(false);

  const handleModelChange = (event) => {
    const selectedId = event.target.value;
    let newData = null;

    if (selectedId === 'lab') newData = datosLab;
    else if (selectedId === 'gaitero') newData = datosGaitero;
    else if (selectedId === 'coche') newData = datosCoche;
    else if (selectedId === 'bombeo') newData = datosBombeo;

    setActiveData(newData);

    if (newData) {
      if (newData.modelPath) {
        setSelectedPath(newData.modelPath);
      } else if (newData.modelPaths) {
        setSelectedPath(null);
      }
    }
  };

  return (
    <div style={{ 
      position: 'fixed',
      inset: 0,
      width: '100%',
      height: '100%',
      overflow: 'hidden',
      margin: 0,
      padding: 0,
      background: 'black',
      fontFamily: 'sans-serif',
      color: 'white'
    }}>
      
      <nav style={{
        position: 'absolute',
        top: '20px',
        left: '50%',
        transform: 'translateX(-50%)',
        zIndex: 9999,
        background: 'rgba(0, 0, 0, 0.6)',
        padding: '5px 15px',
        borderRadius: '30px',
        backdropFilter: 'blur(5px)',
        display: 'flex',
        alignItems: 'center',
        boxShadow: '0 4px 6px rgba(0,0,0,0.2)'
      }}>
        
        <select 
          value={activeData ? activeData.id : ""} 
          onChange={handleModelChange}
          style={{
            backgroundColor: 'transparent',
            color: 'white',
            border: 'none',
            fontSize: '16px',
            fontWeight: 'bold',
            cursor: 'pointer',
            outline: 'none',
            
            padding: '10px 35px 10px 10px',
            minWidth: '200px',

            appearance: 'none',
            WebkitAppearance: 'none',
            MozAppearance: 'none',
            backgroundImage: `url("data:image/svg+xml;charset=US-ASCII,%3Csvg%20xmlns%3D%22http%3A%2F%2Fwww.w3.org%2F2000%2Fsvg%22%20width%3D%22292.4%22%20height%3D%22292.4%22%3E%3Cpath%20fill%3D%22%23FFFFFF%22%20d%3D%22M287%2069.4a17.6%2017.6%200%200%200-13-5.4H18.4c-5%200-9.3%201.8-12.9%205.4A17.6%2017.6%200%200%200%200%2082.2c0%205%201.8%209.3%205.4%2012.9l128%20127.9c3.6%203.6%207.8%205.4%2012.8%205.4s9.2-1.8%2012.8-5.4L287%2095c3.5-3.5%205.4-7.8%205.4-12.8%200-5-1.9-9.2-5.5-12.8z%22%2F%3E%3C%2Fsvg%3E")`,
            backgroundRepeat: 'no-repeat',
            backgroundPosition: 'right 10px center',
            backgroundSize: '12px',
          }}
        >
          <option value="" disabled style={{ color: '#aaa', backgroundColor: '#333' }}>Selecciona modelo...</option>
          <option value="lab" style={{ color: 'white', backgroundColor: '#333' }}>Lab Castreña</option>
          <option value="gaitero" style={{ color: 'white', backgroundColor: '#333' }}>Museo Gaitero</option>
          <option value="coche" style={{ color: 'white', backgroundColor: '#333' }}>Coche</option>
          <option value="bombeo" style={{ color: 'white', backgroundColor: '#333' }}>Bombeo</option>
        </select>

        {activeData && activeData.modelPaths && selectedPath && (
          <button
            onClick={() => setSelectedPath(null)}
            title="Cambiar calidad del modelo"
            style={{
              marginLeft: '15px',
              width: '35px',
              height: '35px',
              borderRadius: '50%',
              background: 'rgba(255, 255, 255, 0.15)',
              color: 'white',
              border: '1px solid rgba(255, 255, 255, 0.4)',
              fontSize: '18px',
              display: 'flex',
              justifyContent: 'center',
              alignItems: 'center',
              cursor: 'pointer',
              transition: 'background 0.2s, transform 0.2s',
            }}
            onMouseEnter={(e) => { e.currentTarget.style.background = 'rgba(255,255,255,0.3)'; e.currentTarget.style.transform = 'scale(1.1)'; }}
            onMouseLeave={(e) => { e.currentTarget.style.background = 'rgba(255,255,255,0.15)'; e.currentTarget.style.transform = 'scale(1)'; }}
          >
            ⚙️
          </button>
        )}

      </nav>

        {/* --- BOTÓN DE AYUDA (?) --- */}
        {activeData && (
          <button
            onClick={() => setIsHelpOpen(true)}
            style={{
              position: 'absolute',
              top: '20px',
              right: '20px',
              width: '40px',
              height: '40px',
              borderRadius: '50%',
              background: 'rgba(0, 0, 0, 0.6)',
              color: 'white',
              border: '1px solid rgba(255, 255, 255, 0.4)',
              fontSize: '20px',
              fontWeight: 'bold',
              cursor: 'pointer',
              zIndex: 10000,
              backdropFilter: 'blur(5px)',
              transition: 'background 0.2s, transform 0.2s',
            }}
            onMouseEnter={(e) => { e.currentTarget.style.background = 'rgba(0,0,0,0.8)'; e.currentTarget.style.transform = 'scale(1.1)'; }}
            onMouseLeave={(e) => { e.currentTarget.style.background = 'rgba(0,0,0,0.6)'; e.currentTarget.style.transform = 'scale(1)'; }}
          >
            ?
          </button>
        )}

      {/* --- POPUP DE CONTROLES --- */}
      {isHelpOpen && activeData && (
        <>
          <div 
            onClick={() => setIsHelpOpen(false)}
            style={{
              position: 'fixed',
              top: 0, left: 0, width: '100%', height: '100%',
              zIndex: 10000,
              cursor: 'pointer'
            }}
          />

          <div style={{
            position: 'absolute',
            top: '50%',
            left: '50%',
            transform: 'translate(-50%, -50%)',
            background: 'rgba(0, 0, 0, 0.85)',
            border: '1px solid rgba(255, 255, 255, 0.2)',
            borderRadius: '12px',
            padding: '25px',
            zIndex: 10001,
            width: '320px',
            boxShadow: '0 8px 32px rgba(0,0,0,0.8)',
            backdropFilter: 'blur(10px)',
            animation: 'fadeIn 0.2s ease-out',
            pointerEvents: 'auto'
          }}>
            {/* Botón de cerrar (X) */}
            <button 
              onClick={() => setIsHelpOpen(false)}
              style={{
                position: 'absolute', top: '10px', right: '15px', 
                background: 'none', border: 'none', color: '#aaa', 
                fontSize: '16px', cursor: 'pointer', fontWeight: 'bold'
              }}
              onMouseEnter={(e) => e.currentTarget.style.color = 'white'}
              onMouseLeave={(e) => e.currentTarget.style.color = '#aaa'}
            >
              ✖
            </button>
            
            <h3 style={{ marginTop: 0, color: '#61dafb', marginBottom: '15px', fontSize: '18px' }}>
              Controles
            </h3>
            
            <ul style={{ paddingLeft: '20px', lineHeight: '1.8', margin: 0, fontSize: '15px' }}>
              {activeData.orbitMode ? (
                <>
                  <li><b>Click Izquierdo + Arrastrar:</b> Rotar modelo 3D</li>
                  <li><b>Click Derecho + Arrastrar:</b> Mover cámara</li>
                  <li><b>Rueda del ratón:</b> Zoom</li>
                </>
              ) : (
                <>
                  <li><b>Click Izquierdo + Arrastrar:</b> Rotar cámara</li>
                  <li><b>Click en 'i' o Flecha:</b> Mover hacia otra localización</li>
                  <li><b>Click en chincheta 📌:</b> Leer anotación</li>
                </>
              )}
            </ul>
          </div>
        </>
      )}

      {!activeData && (
        <div style={{
          position: 'absolute',
          top: '50%',
          left: '50%',
          transform: 'translate(-50%, -50%)',
          textAlign: 'center',
          opacity: 0.8
        }}>
          <img 
            src="/assets/images/bexreal-logo.png" 
            alt="Logo" 
            style={{ 
              maxWidth: '100px',
              marginBottom: '10px',
              height: 'auto'
            }} 
          />
          <h1 style={{ fontSize: '2rem', marginBottom: '1rem' }}>Bienvenido al Visualizador de Gaussians</h1>
          <p>Usa el menú desplegable superior para comenzar</p>
          {MODO_TESTING && (
            <p style={{ color: 'red', fontWeight: 'bold', marginTop: '15px' }}>
              ⚠️ MODO DESARROLLADOR ACTIVADO
            </p>
          )}
        </div>
      )}

      {/* --- PANTALLA DE SELECCIÓN DE CALIDAD --- */}
      {activeData && activeData.modelPaths && !selectedPath && (
        <div style={{
          position: 'absolute', top: 0, left: 0, width: '100vw', height: '100vh',
          backgroundColor: '#111', color: 'white', display: 'flex',
          flexDirection: 'column', justifyContent: 'center', alignItems: 'center',
          zIndex: 1000, padding: '20px', textAlign: 'center'
        }}>
          <h2 style={{ fontSize: '2rem', marginBottom: '10px' }}>
            ¿Qué calidad de modelo quieres ver?
          </h2>
          <p style={{ color: '#aaa', maxWidth: '500px', marginBottom: '40px', lineHeight: '1.5' }}>
            Aviso: Si tu equipo no puede mostrar el modelo 3d de forma fluida, elige un modelo de menor calidad.
          </p>

          <div style={{ display: 'flex', gap: '20px', flexWrap: 'wrap', justifyContent: 'center' }}>
            <button 
              onClick={() => setSelectedPath(activeData.modelPaths.alta)}
              style={{ padding: '15px 30px', fontSize: '1.2rem', cursor: 'pointer', backgroundColor: '#4caf50', color: 'white', border: 'none', borderRadius: '8px', fontWeight: 'bold' }}
            >
              Alta
            </button>
            <button 
              onClick={() => setSelectedPath(activeData.modelPaths.media)}
              style={{ padding: '15px 30px', fontSize: '1.2rem', cursor: 'pointer', backgroundColor: '#ff9800', color: 'white', border: 'none', borderRadius: '8px', fontWeight: 'bold' }}
            >
              Media
            </button>
            <button 
              onClick={() => setSelectedPath(activeData.modelPaths.baja)}
              style={{ padding: '15px 30px', fontSize: '1.2rem', cursor: 'pointer', backgroundColor: '#f44336', color: 'white', border: 'none', borderRadius: '8px', fontWeight: 'bold' }}
            >
              Baja
            </button>
          </div>
        </div>
      )}

      {/* --- RENDERIZADO DEL MODELO (Solo si ya hay una ruta seleccionada) --- */}
      {activeData && selectedPath && (
        <ModelViewer 
          {...activeData} 
          modelPath={selectedPath} /* Le pasamos la ruta final que el usuario ha elegido */
        />
      )}
      
    </div>
  );
}

export default App;